/** Minimum pane width, in pixels */
const PANE_MINWIDTH = "400px";
/** Maximum pane width, in pixels (allowing for Infobox) */
const PANE_MAXWIDTH = "calc(100vw - 470px)";
/** Collapsed pane width, in vw */
const PANE_NARROW = "30vw";
/** Collapsed pane width:  */
const PANE_WIDE = "70vw";

const MAX_STRUCTURE_RADIUS = 50;

export { PANE_MINWIDTH, PANE_MAXWIDTH, PANE_NARROW, PANE_WIDE, MAX_STRUCTURE_RADIUS }
